import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { AuthClient } from '@app/shared/auth';

@Component({
  selector: 'app-start-page',
  imports: [MatButtonModule],
  template: `
    <div class="flex h-full flex-col items-center justify-center gap-y-8">
      <img class="w-1/3" src="assets/images/app-logo.svg" />
      <button
        class="h-16 px-4 py-3 text-lg"
        (click)="login()"
        mat-raised-button
        color="primary"
      >
        ログインしてはじめる
      </button>
    </div>
  `,
  host: { class: 'block h-full w-full' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StartPageComponent {
  readonly #auth = inject(AuthClient);

  /**
   * query param: `redirectTo={string}`
   */
  readonly redirectTo = input<string | undefined>(undefined);

  async login() {
    try {
      await this.#auth.login(this.redirectTo());
    } catch (e) {
      console.error(e);
      // TODO: エラーハンドリング
      alert('ログインに失敗しました');
    }
  }
}
